module.exports = __webpack_public_path__ + "8ce2eb78/img/share-action-icon.9c12578c.svg";